<script lang="ts">
  import { goto } from '$app/navigation';

  import { useWallet } from '@do/svelte-web3-manager';

  import { NoData } from '@shared/ui/no-data';

  import { ArtAssetCardApi, artAssetCardModel } from '@entities/art-asset';
  import { ArtAssetCardSmall } from '@entities/art-asset';
  import type { ArtAssetPurchasedListItem } from '@entities/art-asset/types';

  import { walletSidebarActivity } from '@widgets/wallet-sidebar/model';

  const artAssetCardApi = new ArtAssetCardApi(fetch);

  const wallet = useWallet();

  $: walletAddress = $wallet?.address || null;

  let artAssets: ArtAssetPurchasedListItem[] = [];

  $: if (walletAddress) {
    artAssetCardApi
      .readPurchased(walletAddress)
      .then((res) => {
        artAssets = res;
      })
      .catch((error) => {
        console.error('Error fetching purchased art assets', error);
      });
  }

  function handleGotoArtworks() {
    walletSidebarActivity.close();
    goto('/artworks/');
  }
</script>

<p class="my-4 text-base font-medium"><span class="font-semibold">My Collection</span> ({artAssets.length})</p>

<div>
  {#if artAssets.length}
    <div class="grid grid-cols-2 gap-4 sm:grid-cols-3 md:grid-cols-2">
      {#each artAssets as artAsset}
        <ArtAssetCardSmall {...artAssetCardModel.mapPurchasedApiToData(artAsset)} />
      {/each}
    </div>
  {:else}
    <NoData
      type="collection"
      total="{0}"
      search=""
      filters=""
      buttonName="View Available Artworks"
      on:click="{handleGotoArtworks}"
    />
  {/if}
</div>
